import React, { useState, useEffect } from "react";
import Input from "../../atoms/Input/Input";
import { Navigate } from "react-router-dom";
import useRequest from "../../../context/useRequest";
import ConfirmationModal from "../../atoms/ConfirmationModal/ConfirmationModal";
import FormCountryCodes from "./FormCountryCodes";

const FormRegister = () => {
    const { data: isRegisterData, sendRequest } = useRequest();
    const [isRegister, setIsRegister] = useState({
        first_name: "",
        last_name: "",
        country_code: "",
        phone: "",
        email: "",
        password: "",
        confirm_password: "",
    });
    const [isRegistered, setIsRegistered] = useState(false);
    const [isFieldErrors, setIsFieldErrors] = useState({})
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        if (isRegisterData && Object.keys(isRegisterData).length > 0) {
            setIsRegister((prev) => {
                return JSON.stringify(prev) === JSON.stringify(isRegisterData) ? prev : { ...prev, ...isRegisterData };
            });
        }
    }, [isRegisterData]);
    const registerHandler = (e) => {
        const { name, value } = e.target;
        if (name === "phone" && !/^\d*$/.test(value)) {

            return;
        }
        if (name === "last_name" | name === "first_name" && !/^[A-Za-z]*$/.test(value)) {

            return;
        }

        setIsRegister((prev) => ({
            ...prev,
            [name]: value,
        }));

        setIsFieldErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));

        if (name === "email") {
            setIsEmailVerified(false);
            setShowOtpInput(false);
            setVerificationId(null);
            setOtp("");
            setEmailVerificationMessage("");
        }
    };


    const registerSubmitHandler = async (e) => {
        e.preventDefault();
        const formRegister = new FormData();
        formRegister.append("first_name", isRegister.first_name);
        formRegister.append("last_name", isRegister.last_name);
        formRegister.append("email", isRegister.email);
        formRegister.append("country_code", isRegister.country_code);
        formRegister.append("phone", isRegister.phone);
        formRegister.append("password", isRegister.password);
        formRegister.append("confirm_password", isRegister.confirm_password);

        try {
            const response = await sendRequest({
                method: "POST",
                url: "/auth/register",
                body: formRegister,
            });

            if (response) {
                setShowModal(true);
                // alert("Form submitted successfully!");
            } else {
                console.log("Condition failed. Response or data is missing.");
            }
        } catch (error) {
            // console.error("Error response:", error.response);
            if (error.response?.data?.errors) {
                setIsFieldErrors(error.response.data.errors);
            } else {
                alert("An unexpected error occurred.");
            }
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setIsRegistered(true);
    };
    // CODE ADDED FOR EMAIL VALIDATION PART START
    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [isSendingVerification, setIsSendingVerification] = useState(false);
    const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

    const [verificationId, setVerificationId] = useState(null);
    const [otp, setOtp] = useState("");

    const [showOtpInput, setShowOtpInput] = useState(false);

    const [emailVerificationMessage, setEmailVerificationMessage] =
        useState("");

    const {
        sendRequest: emailVerificationRequest
    } = useRequest();

    const handleValidateEmail = async () => {
        const email = isRegister.email?.trim();

        if (!email) {
            setIsFieldErrors((prev) => ({
                ...prev,
                email: "Please enter your email address.",
            }));
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
            setIsFieldErrors((prev) => ({
                ...prev,
                email: "Please enter a valid email address.",
            }));
            return;
        }

        setIsSendingVerification(true);
        setEmailVerificationMessage("");

        try {
            const formData = new FormData();

            formData.append(
                "module_type",
                "user_register"
            );

            formData.append(
                "email",
                email
            );

            const response = await emailVerificationRequest({
                method: "POST",
                url: "/email-verification/send",
                body: formData,
            });

            if (response.status === true) {

                setVerificationId(response.verification_id);

                setShowOtpInput(true);

                setOtp("");

                setEmailVerificationMessage(
                    "A 6-digit verification code has been sent to your email."
                );

            } else {

                setEmailVerificationMessage(
                    response.message ||
                    "Unable to send verification OTP."
                );
            }

        } catch (error) {

            console.error(error);

            setEmailVerificationMessage(
                error?.message ||
                "Unable to send verification OTP. Please try again."
            );

        } finally {
            setIsSendingVerification(false);
        }
    };

    const handleVerifyOtp = async () => {

        if (!verificationId) {
            setEmailVerificationMessage(
                "Please request a new verification code."
            );
            return;
        }

        if (!otp || otp.length !== 6) {
            setEmailVerificationMessage(
                "Please enter the 6-digit OTP."
            );
            return;
        }

        setIsVerifyingOtp(true);
        setEmailVerificationMessage("");

        try {

            const formData = new FormData();

            formData.append(
                "verification_id",
                verificationId
            );

            formData.append(
                "email",
                isRegister.email.trim()
            );

            formData.append(
                "otp",
                otp
            );

            const response = await emailVerificationRequest({
                method: "POST",
                url: "/email-verification/verify",
                body: formData,
            });

            if (
                response.status === true &&
                response.verified === true
            ) {

                setIsEmailVerified(true);

                setShowOtpInput(false);

                setEmailVerificationMessage(
                    "✓ Email verified successfully."
                );

            } else {

                setEmailVerificationMessage(
                    response.message ||
                    "Invalid OTP. Please try again."
                );
            }

        } catch (error) {
            console.error("OTP verification error:", error);
            const message =
                error?.response?.data?.message ||
                error?.data?.message ||
                "Unable to verify OTP. Please try again.";

            setEmailVerificationMessage(message);
        } finally {
            setIsVerifyingOtp(false);
        }
    };

    // CODE ADDED FOR EMAIL VALIDATION PART END

    if (isRegistered) {
        return <Navigate to="/login" />;
    }


    return (
        <>
            <form
                onSubmit={registerSubmitHandler}
                className="login-form--item-left-form mt-3"
            >
                <div className="login-form--item-left-form-row">
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="first_name"
                            placeholder="First Name"
                            value={isRegister.first_name}
                            onChange={registerHandler}
                            className="form-control"
                            label={
                                <span>
                                    First Name<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                            required
                        />
                        {isFieldErrors.first_name && (
                            <p className="error-message">{isFieldErrors.first_name}</p>
                        )}
                    </div>
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="last_name"
                            placeholder="Last Name"
                            value={isRegister.last_name}
                            onChange={registerHandler}
                            className="form-control"
                            pattern="^[A-Za-z]+$"
                            label={
                                <span>
                                    Last Name<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.last_name && (
                            <p className="error-message">{isFieldErrors.last_name}</p>
                        )}
                    </div>
                </div>
                <div className="form-group input-group login-form--item-left-form-input">
                    <div className="d-flex gap-2 w-100">
                        <Input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={isRegister.email}
                            onChange={registerHandler}
                            className="form-control"
                            // disabled={isEmailVerified}
                            label={
                                <span>
                                    Email<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {!isEmailVerified && (
                            <button
                                type="button"
                                className="btn btn-outline-success"
                                style={{height:'fit-content',alignSelf:'flex-end'}}
                                onClick={handleValidateEmail}
                                disabled={
                                    isSendingVerification ||
                                    !isRegister.email
                                }
                            >
                                {isSendingVerification
                                    ? "Sending..."
                                    : showOtpInput
                                    ? "Resend OTP"
                                    : "Validate Email"}
                            </button>
                        )}
                        {isEmailVerified && (
                            <button
                                type="button"
                                className="btn btn-success"
                                style={{height:'fit-content',alignSelf:'flex-end'}}
                                disabled
                            >
                                ✓ Verified
                            </button>
                        )}   
                    </div>                 
                    {isFieldErrors.email && (
                        <p className="error-message">{isFieldErrors.email}</p>
                    )}
                    {showOtpInput && !isEmailVerified && (
                        <div className="mt-3">

                            <label>
                                Enter OTP
                            </label>

                            <div className="d-flex align-items-center gap-2">

                                <input
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={6}
                                    value={otp}
                                    onChange={(e) => {
                                        const value = e.target.value
                                            .replace(/\D/g, "")
                                            .slice(0, 6);

                                        setOtp(value);
                                    }}
                                    placeholder="Enter 6-digit OTP"
                                    className="form-control"
                                />

                                <button
                                    type="button"
                                    className="btn btn-outline-success"
                                    onClick={handleVerifyOtp}
                                    disabled={
                                        isVerifyingOtp ||
                                        otp.length !== 6
                                    }
                                >
                                    {isVerifyingOtp
                                        ? "Verifying..."
                                        : "Verify OTP"}
                                </button>

                            </div>

                            <small className="text-muted d-block mt-2">
                                Enter the 6-digit code sent to your email.
                            </small>

                        </div>
                    )}

                    {emailVerificationMessage && (
                        <p
                            className="mt-2"
                            style={{
                                color: isEmailVerified
                                    ? "green"
                                    : "#666",
                            }}
                        >
                            {emailVerificationMessage}
                        </p>
                    )}                    
                </div>
                <div className="login-form--item-left-form-row">
                    <div className="form-group input-group login-form--item-left-form-input">
                        <FormCountryCodes 
                            value={isRegister.country_code}
                            onChange={registerHandler}
                        />
                        {isFieldErrors.country_code && (
                            <p className="error-message">{isFieldErrors.country_code}</p>
                        )}
                    </div>

                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="text"
                            name="phone"
                            placeholder="Phone No"
                            value={isRegister.phone}
                            onChange={registerHandler}
                            className="form-control"
                            pattern="^[0-9]*$"
                            minLength="8"
                            maxLength="14"
                            label={
                                <span>
                                    Phone No<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.phone && (
                            <p className="error-message">{isFieldErrors.phone}</p>
                        )}
                    </div>
                </div>
                <div className="login-form--item-left-form-row">
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={isRegister.password}
                            onChange={registerHandler}
                            className="form-control"
                            label={
                                <span>
                                    Password<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.password && (
                            <p className="error-message">{isFieldErrors.password[0]}</p>
                        )}
                    </div>
                    <div className="form-group input-group login-form--item-left-form-input">
                        <Input
                            type="password"
                            name="confirm_password"
                            placeholder="Confirm Password"
                            value={isRegister.confirm_password}
                            onChange={registerHandler}
                            className="form-control"
                            label={
                                <span>
                                    Confirm Password<span style={{ color: "red" }}>*</span>
                                </span>
                            }
                        />
                        {isFieldErrors.confirm_password && (
                            <p className="error-message">{isFieldErrors.confirm_password}</p>
                        )}
                    </div>
                </div>
                
                <div className="form-group login-form--item-left-form-submit">
                    {/* <button type="submit" name="submit" className="submit">
                        Submit
                    </button> */}
                    <button
                        type="submit"
                        name="submit"
                        className="submit"
                        disabled={
                            !isEmailVerified
                        }
                    >
                        {!isEmailVerified
                            ? "Verify Email First"
                            : "Submit"}
                    </button>                     
                </div>

            </form>

            <ConfirmationModal
                show={showModal}
                onClose={handleCloseModal}
                title="Registration Successful"
                body="Your account has been created successfully."
                className="modalshow"
                actions={[
                    {
                        label: "Submit",
                        onClick: handleCloseModal,
                        className: "btn-custom",
                    },
                ]}
            />
        </>
    );
};

export default FormRegister;
